import { useTextInput } from "../../inputs";
import type {
	TextFormGroupDependencies,
	TextFormGroupProps,
} from "./TextFormGroup.d";

/**
 * @function useTextFormGroups
 * @param {TextInputDependencies} deps
 * @returns {TextFormGroupProps}
 */
export const useTextFormGroup = ({
	label,
	...deps
}: TextFormGroupDependencies): TextFormGroupProps => {
	const props = useTextInput({ ...deps, label });

	return {
		...props,
		label,
	};
};
